module.exports = __webpack_public_path__ + "img/news_latter_header_image.7b32b4fe.jpg";